import { useEffect, useRef } from "react";

// Utils
import { format, getCloudinaryRawUrl, getCloudinaryUrl } from "@swiggy-private/js-utils";

// Constants
import {
    FESTIVE_LOTTIE_ASSETS,
    FESTIVE_START_DATE,
    FESTIVE_END_DATE,
    FESTIVE_LOTTIE_IMAGES_ASSET_PATH,
    FESTIVE_LOTTIE_IMAGES_ASSET_COUNT,
} from "@swiggy-private/core-ui";
import { FESTIVE_POST_ADD_DE_TIP_IMG } from "@swiggy-private/cart-ui";

// helper
import { isDateWithinInterval } from "@swiggy-private/core-ui";

export const usePrefetchDetipLottie = () => {
    const preTipLottieFetchRef = useRef<boolean>(false);
    const deTipAddedLottieFetchRef = useRef<boolean>(false);
    const tipSelectedImagesFetchRef = useRef<boolean>(false);
    const preTipLottieImagesFetchRef = useRef<boolean>(false);

    const isFestivePeriod = isDateWithinInterval(new Date(), FESTIVE_START_DATE, FESTIVE_END_DATE);
    useEffect(() => {
        if (isFestivePeriod) {
            if (!preTipLottieFetchRef.current) {
                fetch(getCloudinaryRawUrl(FESTIVE_LOTTIE_ASSETS.FESTIVE_DE_TIP_MAIN_PRE_TIP_FILE_ID) || "")
                    .then(() => {
                        preTipLottieFetchRef.current = true;
                    })
                    .catch();
            }

            if (!preTipLottieImagesFetchRef.current) {
                const preFetchAllImages = async (): Promise<void> => {
                    const fetchPromises = [];
                    for (let i = 0; i <= FESTIVE_LOTTIE_IMAGES_ASSET_COUNT; i++) {
                        const url = `${getCloudinaryUrl(format(FESTIVE_LOTTIE_IMAGES_ASSET_PATH, i))}`;
                        fetchPromises.push(fetch(url).catch());
                    }
                    await Promise.all(fetchPromises);
                    preTipLottieImagesFetchRef.current = true;
                };
                preFetchAllImages();
            }

            if (!tipSelectedImagesFetchRef.current) {
                fetch(getCloudinaryUrl(FESTIVE_POST_ADD_DE_TIP_IMG) || "")
                    .then(() => {
                        tipSelectedImagesFetchRef.current = true;
                    })
                    .catch();
            }

            if (!deTipAddedLottieFetchRef.current) {
                fetch(getCloudinaryRawUrl(FESTIVE_LOTTIE_ASSETS.FESTIVE_DE_TIP_LOTTIE_FILE_ID) || "")
                    .then(() => {
                        deTipAddedLottieFetchRef.current = true;
                    })
                    .catch();
            }
        }
    }, [isFestivePeriod]);
};
